/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import makeApi, { URLS } from "Utils/apiURL";
import Button from "Components/common/Button";
import { toasterState } from "Components/common/toaster";
import Utils from "Utils/utils";
import userDetail from "Stores/userDetail";
import PaywallUtils from "Utils/PaywallUtils";
import { ReactComponent as ThunderBlueIcon } from "Assets/svg/thunderBlue.svg";
import { CustomFieldsInputBox } from "./CustomFields";

const SLOT_COUNT = 30;

const AccountCustomFields = props => {
  const {
    customFieldsEnabled: propCustomFieldsEnabled,
    customFieldsCount: propCustomFieldsCount
  } = props || {};
  const {
    customFieldsEnabled: userCustomFieldsEnabled = false,
    customFieldsCount: userCustomFieldsCount = 0,
    inFreePlan = false,
    planName = ""
  } = userDetail?.userFeatureFlag || {};
  const customFieldsEnabled = propCustomFieldsEnabled ?? userCustomFieldsEnabled;
  const customFieldsCount = propCustomFieldsCount ?? userCustomFieldsCount;

  const [labels, setLabels] = useState({});
  const [loader, setLoader] = useState(false);
  const [isBtnEnabled, setBtnEnabled] = useState(false);

  const loadLabels = async () => {
    try {
      const r = await makeApi({ url: URLS.accountCustomFields, method: "GET" });
      if (r?.status === 200 && r.data) {
        setLabels(r.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadLabels();
  }, []);

  const changeLabel = (key, value) => {
    setBtnEnabled(true);
    setLabels({ ...labels, [key]: value });
  };

  const showAdminPopup = () => {
    Utils.showMessagePopup(
      "Please contact your account administrator to change your custom fields"
    );
    setBtnEnabled(false);
    loadLabels();
  };

  const disableCheckFun = (updatedIndex = 1) => {
    return updatedIndex > customFieldsCount;
  };

  const upgradeCustomFieldsCount = () => {
    PaywallUtils.upgradeUtilsFunction(
      "customFieldsCount",
      false,
      planName,
      inFreePlan,
      { customFieldsCount }
    );
  };

  const labelsMatch = saved => {
    for (let i = 1; i <= SLOT_COUNT; i++) {
      const key = `customField${i}`;
      if ((saved?.[key] || "") !== (labels?.[key] || "")) {
        return false;
      }
    }
    return true;
  };

  const saveLabels = async () => {
    if (!customFieldsEnabled) return;
    if (!Utils.isAdmin()) {
      showAdminPopup();
      return;
    }
    setLoader(true);
    const payload = { id: labels?.id || null };
    for (let i = 1; i <= SLOT_COUNT; i++) {
      const key = `customField${i}`;
      payload[key] = labels?.[key] || "";
    }
    try {
      await makeApi({ url: URLS.accountCustomFields, method: "POST", data: payload });
      const r = await makeApi({ url: URLS.accountCustomFields, method: "GET" });
      if (r?.data && labelsMatch(r.data)) {
        setLabels(r.data);
        toasterState.setToastMsg("Account custom fields updated", "success");
        setBtnEnabled(false);
      } else {
        toasterState.setToastMsg("Labels were not saved. Please try again.", "failure");
        loadLabels();
      }
    } catch (e) {
      if (e?.response?.status === 403) {
        showAdminPopup();
      } else {
        toasterState.setToastMsg("Something went wrong. Please try again later", "failure");
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className={`customFields ${!customFieldsEnabled ? "blurBg" : ""}`}>
      <div className="cusotmFieldsInnerCont">
        <h5 className="titleHeader">Configure Account Custom Fields</h5>
        <div className="fieldList">
          {Array.from({ length: customFieldsCount }, (value, index) => {
            const updatedIndex = index + 1;
            const key = `customField${updatedIndex}`;
            return (
              <CustomFieldsInputBox
                key={key}
                id={key}
                label={`Custom Field ${updatedIndex} Label`}
                changeValue={changeLabel}
                value={labels?.[key]}
                disableCheck={disableCheckFun(updatedIndex)}
                planName={planName}
                indexValue={updatedIndex}
              />
            );
          })}
          <div className="addCustomFields" onClick={upgradeCustomFieldsCount}>
            <div>Add more custom fields</div>
            <ThunderBlueIcon />
          </div>
        </div>

        <div className={`actionCont ${!isBtnEnabled ? "btnDisabled" : ""}`}>
          <Button
            id="accountCustomField"
            name="accountCustomField"
            btnText="Save Changes"
            icon={false}
            iconName=""
            type="button"
            className={`accountCustomField ${loader ? "loading" : ""}`}
            loader={loader}
            click={saveLabels}
          />
        </div>
      </div>
    </div>
  );
};

export default observer(AccountCustomFields);
export { AccountCustomFields };
